import { render, staticRenderFns } from "./impersonate-popup.vue?vue&type=template&id=23a8923c"
import script from "./impersonate-popup.ts?vue&type=script&lang=ts&external"
export * from "./impersonate-popup.ts?vue&type=script&lang=ts&external"
import style0 from "./impersonate-popup.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports